import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://nauka-spiewu.pl/vocaldemy/back/public/'
    // baseURL: 'http://localhost:8088/'
});

export default instance;